module.exports = __webpack_public_path__ + "img/res5.069a22ad.jpg";